/*
 * Why are we storing the values directly on "this"?
 *
 * FDT was swapping the rowIndex in the props before _stopEditing had
 * a chance to be called using the correct rowIndex.
 *
 * By updating the properties in componentDidUpdate it allows the
 * _stopEditing to be called before FDT changes the values that it uses to
 * update the correct cell.
 *
 * Relates to issue: https://github.com/SHOFLO/Issues/issues/2308
 */

export default {
  componentWillMount() {
    let { rowIndex, columnId } = this.props;

    this.columnId = columnId;
    this.rowIndex = rowIndex;
  },

  componentDidUpdate() {
    this.columnId = this.props.columnId;
    this.rowIndex = this.props.rowIndex;
  },
};
